import { Button, Spin } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import appConfig from "@/config/appConfig";
import { userRole } from "@/constant";
import DeviceListOnSiteLocation from "./DeviceListOnSiteLocation";
import UserListOnSiteLocation from "./UserListOnSiteLocation";
import { flare } from "@flareapp/js";

const SiteLocationView = () => {
  const { userDetails } = useSelector((state) => state.user);

  const { siteLocationId } = useParams();
  const navigate = useNavigate();
  const [siteLocationDetails, setSiteLocationDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // get site location
  const getSiteLocation = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`/site-location/` + siteLocationId, {
        withCredentials: true,
      });
      if (response) {
        setSiteLocationDetails(response.data);
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getSiteLocation();
    document.title = `${appConfig.name} - Site Location Details`;
  }, []);

  return (
    <Spin spinning={isLoading}>
      <div className="az-content-body p-0 px-md-3">
        <div className="container-fluid">
          <div className="col-lg-12">
            <div className="card  p-3 mb-3">
              <div className="row mt-4 px-3">
                <div>
                  <div className="mb-3">
                    <h6 className="fw-bold mb-0"> Location Name: </h6>
                    <div> {siteLocationDetails?.name} </div>
                  </div>
                  {/* <div className="mb-3">
                  <h6 className="fw-bold mb-0"> Building Name: </h6>
                  <div> {siteLocationDetails?.buildingName} </div>
                </div> */}
                  <div className="mb-3">
                    <h6 className="fw-bold mb-0"> Address: </h6>
                    <div> {siteLocationDetails?.buildingAddress1} </div>
                    <div> {siteLocationDetails?.buildingAddress2} </div>
                    <div>{`${siteLocationDetails?.buildingPostalCode} ${siteLocationDetails?.city} `}</div>
                    <div>{`${siteLocationDetails?.state}, ${siteLocationDetails?.country} `}</div>
                    <div className="mt-3">Latitude: {siteLocationDetails?.latitude}</div>
                    <div> Longitude: {siteLocationDetails?.longitude}</div>
                  </div>
                  <div className="mb-3">
                    <h6 className="fw-bold mb-0"> Remark: </h6>
                    <div> {siteLocationDetails?.remark} </div>
                  </div>
                  <div className="mb-3">
                    <h6 className="fw-bold mb-0"> Contact Person: </h6>
                    <div> Name: {siteLocationDetails?.contactPersonName} </div>
                    <div> Email: {siteLocationDetails?.contactPersonEmail} </div>
                    <div> Phone: +6{siteLocationDetails?.contactPersonPhone} </div>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-end">
                {[userRole.superAdmin, userRole.businessAdmin].includes(userDetails.role) && (
                  <Link to={`/site-locations/edit/${siteLocationId}`} className="me-2">
                    <Button type="primary">Edit</Button>
                  </Link>
                )}
                <Button type="primary" className="bg-secondary" onClick={() => navigate(-1)}>
                  Back
                </Button>
              </div>
            </div>
          </div>
        </div>
        {userDetails?.role !== userRole.installer &&
          userDetails?.role !== userRole.user &&
          userDetails?.role !== userRole.public && (
            <div className="mb-3">
              <UserListOnSiteLocation siteLocationId={siteLocationId} />
            </div>
          )}
        <DeviceListOnSiteLocation siteLocationId={siteLocationId} />
      </div>
    </Spin>
  );
};

export default SiteLocationView;
